<div class="d-flex justify-content-center mt-5">
    <img src="../../../../assets/img/bp-support/setup-failed.svg" />
</div>

<div class="text-center mt-3" *ngIf="!showB2BHint">
    <p>{{ 'BUSINESS_PARTNER_SUPPORT.HELP.SETUP_FAILED' | translate }}</p>
    <p *ngIf="!error && !invalidToken">{{ 'BUSINESS_PARTNER_SUPPORT.HELP.SUPPORT_HINT' | translate }}</p>
</div>

<div class="text-center mt-3" *ngIf="showB2BHint">
    <p>{{ 'BUSINESS_PARTNER_SUPPORT.HELP.SETUP_FAILED_B2B' | translate }}</p>
    <p>{{ 'BUSINESS_PARTNER_SUPPORT.HELP.SUPPORT_HINT_B2B' | translate }}</p>
</div>

<div class="d-flex justify-content-center mt-4" *ngIf="showB2BHint">
    <a
        [routerLink]="['/register-end-customer']"
        [queryParams]="bpToken ? { token: bpToken } : {}"
        mat-raised-button
        color="primary"
    >
        {{ 'BUSINESS_PARTNER_SUPPORT.HELP.REGISTRATION_LINK' | translate }}
    </a>
</div>

<div class="d-flex justify-content-center mt-4" *ngIf="error">
    <a [routerLink]="['../']" [queryParams]="bpToken ? { token: bpToken } : {}" mat-raised-button color="primary">
        {{ 'BUSINESS_PARTNER_SUPPORT.HELP.RETRY_LINK' | translate }}
    </a>
</div>
